var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackListOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9977 12.0066V6.00332C10.9977 5.45302 11.4479 5.00277 11.9982 5.00277C12.5485 5.00277 12.9988 5.45302 12.9988 6.00332V12.0066C12.9988 12.5569 12.5485 13.0072 11.9982 13.0072C11.4479 13.0072 10.9977 12.5569 10.9977 12.0066ZM11.9982 14.0077C11.1678 14.0077 10.4974 14.6781 10.4974 15.5086C10.4974 16.339 11.1678 17.0094 11.9982 17.0094C12.8287 17.0094 13.4991 16.339 13.4991 15.5086C13.4991 14.6781 12.8287 14.0077 11.9982 14.0077ZM23.5846 18.8904C22.8843 20.2412 21.4134 21.0116 19.5724 21.0116H4.43406C2.58303 21.0116 1.12222 20.2412 0.421837 18.8904C-0.288556 17.5297 -0.0884455 15.7887 0.922113 14.3279L8.96656 1.60089C9.67696 0.580321 10.7976 0 11.9982 0C13.1989 0 14.3195 0.580321 14.9999 1.57087L23.0844 14.3479C24.0949 15.8087 24.285 17.5397 23.5746 18.8904H23.5846ZM21.4335 15.4686C21.4335 15.4686 21.4134 15.4485 21.4134 15.4285L13.339 2.67148C13.0488 2.26125 12.5485 2.00111 11.9982 2.00111C11.4479 2.00111 10.9477 2.26125 10.6375 2.7115L2.58303 15.4285C1.96269 16.309 1.82261 17.2696 2.18281 17.9599C2.533 18.6403 3.33345 19.0105 4.42405 19.0105H19.5524C20.643 19.0105 21.4435 18.6403 21.7937 17.9599C22.1539 17.2696 22.0138 16.309 21.4235 15.4686H21.4335Z",
    fill: "#062F67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackListOff);
export default __webpack_public_path__ + "static/media/blackListOff.0b225a2322ec9716f655600a57e716ed.svg";
export { ForwardRef as ReactComponent };